import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { useParams, useHistory, Route } from 'react-router-dom';
import cn from 'classnames';

import { useUserState, useUserStateDispatch } from 'contexts/auth-context';
import { setIdAlert, userState } from 'contexts/actions/authActions';

import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  Widget,
  BtnPurpleIconText,
  BtnGreyIconText24,
  TableArticles,
  NavRelease,
  ModalWindow,
  WidgetRelease,
  ReleaseText,
  Loader,
  СoincidencesPopap,
  DiagramChart,
  LineChart
} from 'components/common/Elements/Elements';

import {
  getRequest,
  deleteRequest,
  postRequest,
  patchRequest
} from 'utils/requests';

import RemoteOutputs from './parts/RemoteOutputs/RemoteOutputs';
import RemoteReleases from './parts/RemoteReleases/RemoteReleases';
import AddOutputs from './parts/AddOutputs/AddOutputs';
import AlertDelArticle from './parts/AlertDelArticle/AlertDelArticle';
import AlertDelPressRelase from './parts/AlertDelPressRelase/AlertDelPressRelase';
import DiagramModal from './parts/DiagramModal/DiagramModal';
import RenameRadector from './parts/RenameRadector/RenameRadector';

import {
  pasrsGropsForReleases,
  pasrsReleaseForStatistics,
  pasrsGropsForChips,
  parsChartFromBack
} from './helpers/helpers';

import classes from './Release.module.scss';

const Release = ({ mixpanel, onOfNotif }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;
  const dispatch = useUserStateDispatch();
  const isTrial = useUserState().user.trial;
  const userInfo = useUserState().user;

  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState(true);
  const [modalDelArticles, setModalDelArticles] = useState(false);
  const [modalDelRelease, setModalDelRelease] = useState(false);
  const [modalAddRelease, setModalAddRelease] = useState(false);
  const [modalAlertDelArticle, setModalAlertDelArticle] = useState(false);
  const [modalAlertDelRelease, setModalAlertDelRelease] = useState(false);
  const [showAllList, setShowAllList] = useState(false);

  const [modalInputName, setModalInputName] = useState(false);

  const [dataArticles, setDataArticles] = useState([]);
  const [dataDelRelease, setDataDelRelease] = useState([]);
  const [dataChips, setDataChips] = useState([]);
  const [urlForChips, setUrlForChips] = useState('');

  const [changeForDel, setChangeForDel] = useState();
  const [changeForRename, setChangeForRename] = useState();

  const [coincidences, setCoincidences] = useState(false);

  const [ratioData, setRatioData] = useState();

  const [chartData, setChartData] = useState();

  const [diagramDownload, setDiagramDownload] = useState();
  const [lineChartDownload, setLineChartDownload] = useState();

  let history = useHistory();
  const params = useParams();

  useEffect(() => {
    if (username) {
      mixpanel.track(`User ${username} enter Release page`);
    }
    // eslint-disable-next-line
  }, [username]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [history.location.pathname]);

  const getData = () => {
    getRequest(`/api/press-release-groups/${params.groupId}/`)
      .then(res => {
        setIdAlert({
          title: res.pressReleases[0].articleTitle,
          id: res.alertId,
          groupId: res.id
        })(dispatch);
        const forData = pasrsGropsForChips(res);
        if (forData.length === 1) {
          history.replace(`/groups/${params.groupId}/${forData[0].id}`);
        }
        setDataChips(forData);
        setUrlForChips(`/api/press-release-groups/${params.groupId}/`);
      })
      .catch(err => {
        console.log(err);
      });

    getRequest(`/api/press-releases/?deleted=true&group_id=${params.groupId}`)
      .then(res => {
        setDataDelRelease(res);
      })
      .catch(err => {
        console.log(err);
      });

    if (!params.releaseId) {
      getRequest(`/api/press-release-groups/${params.groupId}/`)
        .then(res => {
          setDataArticles(pasrsGropsForReleases(res));
          setDataChips(pasrsGropsForChips(res));
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
        });

      getRequest(`/api/press-release-groups/${params.groupId}/chart`)
        .then(res => {
          setChartData(parsChartFromBack(res));
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      setLoadingText(true);
      getRelease();
    }
  };

  const getRelease = () => {
    getRequest(
      `/api/press-releases/${params.releaseId}/?show_articles_deleted=true`
    )
      .then(res => {
        setDataArticles(pasrsReleaseForStatistics(res));
        setLoading(false);
        setLoadingText(false);
      })
      .catch(err => {
        console.log(err);
      });
    getRequest(`/api/press-releases/${params.releaseId}/chart`)
      .then(res => {
        setChartData(parsChartFromBack(res));
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleStatistics = idRelease => {
    trackingEvent('look_statisticks', mixpanel, username);
    if (idRelease !== 'allReleaseId') {
      history.push(`/groups/${params.groupId}/${idRelease}`);
    } else {
      history.push(`/groups/${params.groupId}`);
    }
  };

  const delArticles = (id, pressReleaseId) => {
    trackingEvent('open_delete_article', mixpanel, username);
    setChangeForDel({ id: id, pressReleaseId: pressReleaseId });
    setModalAlertDelArticle(true);
  };

  const delOption = _id => {
    setChangeForDel(_id);
    setModalAlertDelRelease(true);
  };

  const handleDel = () => {
    trackingEvent('delete_article', mixpanel, username);

    const url = params.releaseId
      ? `/api/press-releases/${params.releaseId}/article/${changeForDel.id}`
      : `/api/press-release-groups/${params.groupId}/article/${changeForDel.id}`;

    setModalAlertDelArticle(false);
    deleteRequest(url)
      .then(() => {
        if (params.releaseId) {
          getRelease();
        } else {
          getData();
        }
        onOfNotif('on', t('notif', 'OUTPUT_DELL', language), false, '2000');
      })
      .catch(err => {
        console.log(err);
        setModalAlertDelArticle(false);
      });
  };

  const handleDelRelease = () => {
    trackingEvent('delete_campaign', mixpanel, username);

    setLoading(true);
    setModalAlertDelRelease(false);
    deleteRequest(
      `/api/press-releases/${changeForDel ? changeForDel : params.releaseId}/`
    )
      .then(() => {
        history.push(`/groups/${params.groupId}`);
        if (changeForDel) {
          setChangeForDel('');
          getData();
        }
        onOfNotif('on', t('notif', 'VERSION_DELL', language), false, '2000');
      })
      .catch(err => {
        console.log(err);
        setModalAlertDelRelease(false);
      });
  };

  const renameOption = _id => {
    setChangeForRename(_id);
    setModalInputName(true);
  };

  const onRename = newName => {
    trackingEvent('save_rename_campaign_option', mixpanel, username);
    setModalInputName(false);

    const url = `/api/press-releases/${changeForRename}/`;

    const REQ_BODY = { title: newName };

    patchRequest(url, REQ_BODY)
      .then(() => {
        const newChips = dataChips.map(item => {
          return item.id === changeForRename
            ? { ...item, name: newName }
            : item;
        });
        setDataChips(newChips);
        mixpanel.track(`User ${username} RENAME`);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onAddOptionRelease = () => {
    userState({
      error: undefined
    })(dispatch);

    trackingEvent('open_add_first_campaign', mixpanel, username);
    if (dataDelRelease.length + dataChips.length < 5 || !userInfo.trial) {
      trackingEvent('open_add_campaign', mixpanel, username);
      history.push(`/newrelease/${params.groupId}`);
    } else {
      userState({
        error: 400
      })(dispatch);
    }
  };

  const onShowList = () => {
    trackingEvent('show_all_articles', mixpanel, username);
    setShowAllList(!showAllList);
  };

  if (loading) {
    return <Loader />;
  }

  const onReestablishOption = id => {
    trackingEvent('reestablish_campaign', mixpanel, username);

    const url = `/api/press-releases/${id}/restore`;

    setModalDelArticles(false);
    setLoading(true);
    postRequest(url)
      .then(() => {
        getData();
        setModalDelRelease(false);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      });
  };

  const onReestablish = e => {
    trackingEvent('reestablish_article', mixpanel, username);
    const url = `/api/press-releases/${params.releaseId}/article/${e}`;
    setModalDelArticles(false);
    postRequest(url)
      .then(() => {
        getRelease();
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onSelectRatioId = id => {
    trackingEvent('open_ratio', mixpanel, username);
    setRatioData(dataArticles.articles.find(el => el.id === id));
    setCoincidences(true);
  };

  const onDownload = (data, nameChart) => {
    trackingEvent('download_chart', mixpanel, username);
    setDiagramDownload({ data, nameChart });
  };

  const onDownloadLineChart = (data, nameChart) => {
    trackingEvent('download_chart', mixpanel, username);
    setLineChartDownload({ data });
  };

  const changeHeaderText = id => {
    const ind = dataChips.findIndex(element => element.id === id);

    if (ind === 0) {
      return t('release', 'RENAME_CAMPAIGN', language);
    } else {
      return t('release', 'RENAME_OPTIONS', language);
    }
  };

  return (
    <>
      <ModalWindow
        headerText={changeHeaderText(changeForRename)}
        isOpen={modalInputName}
        setIsOpen={() => {
          trackingEvent('close_rename_campaign_option', mixpanel, username);
          setModalInputName(false);
        }}
      >
        <RenameRadector
          onCancel={() => {
            trackingEvent('close_rename_campaign_option', mixpanel, username);
            setModalInputName(false);
          }}
          onClickOk={onRename}
        />
      </ModalWindow>

      <ModalWindow
        headerText={t('release', 'DEL_ARTICLES', language)}
        isOpen={modalDelArticles}
        setIsOpen={() => {
          trackingEvent('close_deleted_articles', mixpanel, username);
          setModalDelArticles(!modalDelArticles);
        }}
      >
        <RemoteOutputs
          dataArticles={dataArticles}
          onReestablish={onReestablish}
        />
      </ModalWindow>
      <ModalWindow
        headerText={t('release', 'DELETED_OPTIONS', language)}
        isOpen={modalDelRelease}
        setIsOpen={() => {
          trackingEvent('close_deleted_campaigns', mixpanel, username);
          setModalDelRelease(!modalDelRelease);
        }}
      >
        <RemoteReleases
          dataDelRelease={dataDelRelease}
          onReestablish={onReestablishOption}
        />
      </ModalWindow>
      <ModalWindow
        headerText={t('release', 'Q_MISSING_SOMETHING', language)}
        isOpen={modalAddRelease}
        setIsOpen={() => {
          trackingEvent('close_add_article', mixpanel, username);
          setModalAddRelease(!modalAddRelease);
        }}
      >
        <AddOutputs
          setIsOpen={() => setModalAddRelease(!modalAddRelease)}
          getData={getData}
          onOfNotif={onOfNotif}
          mixpanel={mixpanel}
        />
      </ModalWindow>
      <ModalWindow
        headerText={t('release', 'Q_WANT_DEL_ARTICLE', language)}
        isOpen={modalAlertDelArticle}
        setIsOpen={() => {
          trackingEvent('cancel_delete_article', mixpanel, username);
          setModalAlertDelArticle(!modalAlertDelArticle);
        }}
      >
        <AlertDelArticle
          handleCancel={() => {
            trackingEvent('cancel_delete_article', mixpanel, username);
            setModalAlertDelArticle(false);
          }}
          handleDel={handleDel}
          idForDel={changeForDel}
        />
      </ModalWindow>
      <ModalWindow
        headerText={t('release', 'Q_WANT_DEL_RELEASE', language)}
        isOpen={modalAlertDelRelease}
        setIsOpen={() => {
          trackingEvent('cancel_delete_campaign', mixpanel, username);
          setModalAlertDelRelease(!modalAlertDelRelease);
        }}
      >
        <AlertDelPressRelase
          handleCancel={() => {
            trackingEvent('cancel_delete_campaign', mixpanel, username);
            setModalAlertDelRelease(false);
          }}
          handleDel={handleDelRelease}
        />
      </ModalWindow>
      {diagramDownload && (
        <DiagramModal
          setDiagramDownload={setDiagramDownload}
          onOfNotif={onOfNotif}
          const
          options={{
            width: 350,
            scale: 2
          }}
        >
          <div id="capture">
            <DiagramChart
              idBtnDownload={'idExport'}
              data={diagramDownload.data}
              nameChart={diagramDownload.nameChart}
              isAnimation={false}
              onDownload={() => {}}
            />
          </div>
        </DiagramModal>
      )}

      {lineChartDownload && (
        <DiagramModal
          setDiagramDownload={setLineChartDownload}
          onOfNotif={onOfNotif}
          options={{
            width: 730,
            scale: 2
          }}
        >
          <div id="capture">
            <LineChart
              idBtnDownload={'idExport'}
              data={lineChartDownload.data}
              isAnimation={false}
              onDownload={() => {}}
            />
          </div>
        </DiagramModal>
      )}

      <div className={cn(classes.navWrap, isTrial && classes.navWrap_trial)}>
        <nav className={classes.navRelease}>
          <NavRelease
            dataNav={dataChips}
            onClickChips={handleStatistics}
            mainUrl={urlForChips}
            onClickAdd={onAddOptionRelease}
            handleDelRelease={id => {
              trackingEvent('open_delete_campaign', mixpanel, username);
              delOption(id);
            }}
            handleRename={id => {
              trackingEvent('open_rename_campaign_option', mixpanel, username);
              renameOption(id);
            }}
          />
        </nav>
      </div>
      <section className={classes.release}>
        <div className={classes.boxReleases}>
          <Route
            exact
            path="/groups/:groupId"
            component={() => {
              return (
                <>
                  {dataArticles.releases &&
                    dataArticles.releases.map(
                      ({ date, idRelease, heading, deleted }, index) => (
                        <Fragment key={idRelease}>
                          {!deleted && (
                            <WidgetRelease
                              date={date}
                              option={index + 1}
                              title={heading}
                              textButton={t(
                                'release',
                                'LOOCK_STATISTICS',
                                language
                              )}
                              className={classes.widgetRelease}
                              onClick={() => {
                                handleStatistics(idRelease);
                              }}
                              handleDelRelease={() => {
                                trackingEvent(
                                  'open_delete_campaign',
                                  mixpanel,
                                  username
                                );
                                delOption(idRelease);
                              }}
                            />
                          )}
                        </Fragment>
                      )
                    )}
                </>
              );
            }}
          />
          <Route
            exact
            path="/groups/:groupId/:releaseId"
            component={() => {
              return (
                <div className={classes.textRelease}>
                  {loadingText && <Loader />}
                  {!loadingText && dataArticles.release && (
                    <ReleaseText textInfo={dataArticles.release} />
                  )}
                </div>
              );
            }}
          />
          {dataDelRelease.length > 0 && (
            <div className={classes.paginBtnBox}>
              <button
                className={classes.paginBtn}
                onClick={() => {
                  trackingEvent('deleted_campaigns', mixpanel, username);
                  setModalDelRelease(true);
                }}
              >
                {t('release', 'DELETED_OPTIONS', language)}
              </button>
            </div>
          )}
        </div>
        <div className={classes.info}>
          <div className={classes.widgetWrap}>
            <Widget
              title={t('release', 'COUNT_ARTICLES', language)}
              text={dataArticles.ArticlesStatistics.widget.NumberOfOutputs}
              color={'pink'}
              icon={'Icn_Copy'}
            />
            <Widget
              title={t('release', 'TOTAL_AUDIENCE', language)}
              text={dataArticles.ArticlesStatistics.widget.totalAudience}
              color={'purple'}
              icon={'Icn_Audience'}
            />
            <Widget
              title={t('release', 'NUMBER_VIEWS', language)}
              text={dataArticles.ArticlesStatistics.widget.totalNumberOfViews}
              color={'green'}
              icon={'Icn_Views'}
            />
          </div>
          <div className={classes.titleArticles}>
            <h2 className={classes.title}>
              <p>
                {t('release', 'LIST_OF_OUTPUTS', language)}{' '}
                <span>{`(${dataArticles.articles.length})`}</span>
              </p>
            </h2>
            {params.releaseId && (
              <Media
                queries={{
                  large: '(min-width: 1280px)'
                }}
              >
                {matches => (
                  <BtnGreyIconText24
                    className={classes.addArticles}
                    textButton={
                      matches.large
                        ? t('release', 'ADD_OUTPUT', language)
                        : t('release', 'ADD', language)
                    }
                    icon={'Icn_Add-3'}
                    onClick={() => {
                      trackingEvent('open_add_article', mixpanel, username);
                      setModalAddRelease(true);
                    }}
                  />
                )}
              </Media>
            )}
          </div>
          <div className={classes.wrapForMobile}>
            {chartData && (
              <LineChart
                data={chartData[0].data}
                onDownload={onDownloadLineChart}
              />
            )}
            <TableArticles
              onRatio={onSelectRatioId}
              dataArticles={dataArticles.articles}
              clickIconRow={delArticles}
              isDeletable={true}
              showAllList={showAllList}
              className={classes.table_mobile}
            />
          </div>
          <div className={cn(classes.paginBtnBox, classes.paginBtnBox_center)}>
            {params.releaseId && (
              <button
                className={classes.paginBtn}
                onClick={() => {
                  trackingEvent('deleted_articles', mixpanel, username);
                  setModalDelArticles(true);
                }}
              >
                {t('release', 'DELETED', language)}
              </button>
            )}
            {dataArticles.articles.length > 4 && (
              <button
                className={cn(classes.paginBtn, classes.paginBtn_right)}
                onClick={onShowList}
              >
                {!showAllList
                  ? t('release', 'SHOW_ALL', language)
                  : t('release', 'SHOW_FOUR', language)}
              </button>
            )}
          </div>
          <div className={classes.chartBox}>
            {chartData &&
              chartData.map((dataForChart, index) => {
                return index !== 0 ? (
                  <Fragment key={index}>
                    <DiagramChart
                      data={dataForChart.data}
                      nameChart={t(
                        'diagramChart',
                        dataForChart.titleChart,
                        language
                      )}
                      onDownload={onDownload}
                    />
                  </Fragment>
                ) : (
                  <Fragment key={index}></Fragment>
                );
              })}
          </div>
          {params.releaseId && dataChips.length > 1 && (
            <BtnPurpleIconText
              textButton={t('release', 'DELETE_VARIANT', language)}
              icon={'Icn_Delete1'}
              onClick={() => {
                setModalAlertDelRelease(true);
              }}
              className={classes.btnDelRelease}
            />
          )}
        </div>
        {coincidences && (
          <СoincidencesPopap
            dataCoincidences={ratioData}
            onClose={() => {
              trackingEvent('close_ratio', mixpanel, username);
              setCoincidences(false);
              mixpanel = { mixpanel };
            }}
            onOfNotif={onOfNotif}
          />
        )}
      </section>
    </>
  );
};

Release.propTypes = {
  onOfNotif: PropTypes.func,
  mixpanel: PropTypes.object
};

export default Release;
